export const newsData = [
  {
    id: 1,
    date: "03.2017",
    category: "AWARD",
    title: "宁波｜三联书店 荣获 2017 年最佳改造设计奖",
    titleEn: "Ningbo Sanlian Bookstore Wins Best Renovation Design Award 2017",
    excerpt: "凭借「宁波三联书店」项目在室内设计改造大奖中脱颖而出，评审团对其空间诗意与结构创新给予高度评价。",
    excerptEn: "The Ningbo Sanlian Bookstore project stood out at the Interior Design Renovation Awards, with the jury highly commending its spatial poetry and structural innovation.",
    image: "https://static.readdy.ai/image/c8608e961562513b854fa363830f8188/b97de183f4518b23db87e95070f4a80f.jpeg"
  },
  {
    id: 2,
    date: "08.2023",
    category: "PROJECT",
    title: "蔚来中心｜合肥新桥产业园项目",
    titleEn: "NIO House | Hefei Xinqiao Industrial Park Project",
    excerpt: "经过两年多的设计管理，项目于2023年8月竣工完成，成为全球首家「零碳」项目。",
    excerptEn: "After more than two years of design management, the project was completed in August 2023, becoming the world's first 'zero-carbon' NIO House.",
    image: "https://static.readdy.ai/image/c8608e961562513b854fa363830f8188/b7d831be2f4dcdc88e3dc6c63f1352c1.jpeg"
  },
  {
    id: 3,
    date: "03.2019",
    category: "INSIGHT",
    title: "当代建筑中的材料叙事——工作室研究报告发布",
    titleEn: "Material Narratives in Contemporary Architecture — Studio Research Report Released",
    excerpt: "工作室发布的《室内设计中纤维艺术的表现与应用》在《建筑细部》杂志第2018年21期发布。",
    excerptEn: "The studio's paper 'Expression and Application of Fiber Art in Interior Design' was published in Architectural Detail Magazine, Issue 21, 2018.",
    image: "https://public.readdy.ai/ai/img_res/0b1902a9cd6d492cdc5ad49856e03748.jpg"
  }
];
